import { AuthRole } from '@gishub/domain';

export const SESSION_STORAGE_KEY = 'sf_auth';

export interface AuthState {
  username: string;
  password: string;
  alias: string;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  recaptchaToken: string | null;
  token: string | null;
  userId: number | null;
  fullName: string | null;
  email: string | null;
  documentNumber: string | null;
  accessToken: string | null;
  roles: AuthRole[];
  sessionExpiredMessage: string | null;
}

export const initialAuthState: AuthState = {
  username: '',
  password: '',
  alias: 'sisfor',
  isAuthenticated: false,
  loading: false,
  error: null,
  recaptchaToken: null,
  token: null,
  userId: null,
  fullName: null,
  email: null,
  documentNumber: null,
  accessToken: null,
  roles: [],
  sessionExpiredMessage: null,
};

export interface AuthSession {
  isAuthenticated: boolean;
  username: string;
  fullName: string | null;
  email: string | null;
  documentNumber: string | null;
  token: string | null;
  userId: number | null;
  accessToken: string | null;
  roles: AuthRole[];
}

export function toSession(state: AuthState): AuthSession {
  return {
    isAuthenticated: state.isAuthenticated,
    username: state.username,
    fullName: state.fullName,
    email: state.email,
    documentNumber: state.documentNumber,
    token: state.token,
    userId: state.userId,
    accessToken: state.accessToken,
    roles: state.roles,
  };
}